import {
  FETCH_RECORDS,
  FETCH_RECORDS_SUCCESS,
  FETCH_RECORDS_FAIL,
  WAIT,
  WAIT_SUCCESS,
  WAIT_FAIL,
  LOGIN_FAIL,
  LOGIN,
  LOGIN_SUCCESS
} from "./types";
import {
  delRequest,
  getRequest,
  postRequest,
  putRequest
} from "../../../core/network";
import endpoints from "../../../constants/endPoints.json";
import { notification } from "antd";
import download from "downloadjs";
import i18n from "../../../i18n";

export const getProducts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.products)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getProductsSimplified = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.productsSimplified)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getProductsStatistics = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.productsStatistics)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const exportProducts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.productsExport)
    .then((response) => {
      const { data } = response;
      notification.info({
        message: data?.message
      });
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const exportProductSales = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.productSalesExport)
    .then((response) => {
      const { data } = response;
      notification.info({
        message: data?.message
      });
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const addProducts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.products)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/ims/admin/products");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addProductsMapping = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.productsMapping)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      notification.success({
        message: data?.message
      });
      navigate && navigate("/products");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editProducts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.partner.products)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteProducts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.partner.products)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getWarehouses = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.warehouses)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const downloadInboundReceipt = (inboundId) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  getRequest({ inboundId, responseType: "arraybuffer" }, undefined, token, endpoints.partner.inboundReceipt)
    .then((response) => {
      download(response.data, response.headers["filename"] || "inbound-receipt.pdf", "application/pdf");
      return dispatch({ type: WAIT_SUCCESS });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message || "Download failed"
      });
      return dispatch({ type: WAIT_FAIL });
    });
};

export const getInbounds = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.inbounds)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const exportInbounds = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.exportInbounds)
    .then((response) => {
      const { data } = response;
      notification.info({
        message: data?.message
      });
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const addInbounds = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, { responseType: "arraybuffer" }, undefined, token, endpoints.partner.inbounds)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: "Inbound created successfully"
      });
      navigate && navigate("/inbounds");
      download(response.data, response.headers["filename"], "application/pdf")
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.orders)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      navigate && navigate("/orders");
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const exportOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.ordersExport)
    .then((response) => {
      const { data } = response;
      notification.info({
        message: data?.message
      });
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getOrderStatistics = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.ordersStatistics)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addOrderScratch = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.orders)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message
      });
      if (data?.warning) {
        notification.warning({
          message: i18n.t("orders.sameDayAfterCutoffWarning"),
        });
      }
      dispatch({
        type: WAIT_SUCCESS
      });
      navigate && navigate("/orders");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const updateOrderFulfillment = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  const { orderId } = data

  postRequest(data, undefined, undefined, token, endpoints.partner.orderFulfillment)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message
      });
      dispatch({
        type: WAIT_SUCCESS
      });
      navigate && navigate(`/orders/${orderId}`);
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const deleteOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.partner.orders)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getCOD = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.cod)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getTransactions = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.transactions)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const exportTransactions = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.transactionsExport)
    .then((response) => {
      const { data } = response;
      notification.info({
        message: data?.message
      });
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getDashboard = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.dashboard)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getKeys = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.keys)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addKey = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.partner.keys)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message
      });
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteKey = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.partner.keys)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getExchanges = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.exchanges)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addExchange = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.exchanges)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/exchanges");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addExchangeScratch = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.exchangeScratch)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/exchanges");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addReturn = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.returns)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message
      });
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/returns");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addReturnScratch = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.returnScratch)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message
      });
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/returns");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getReturns = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.returns)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteReturn = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.partner.returns)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const cancelOrder = (data, navigate, refreshQuery) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return postRequest(data, undefined, undefined, token, endpoints.partner.cancelOrder)
    .then((response) => {
      const { data: responseData } = response;
      dispatch({
        type: WAIT_SUCCESS
      });
      notification.success({
        message: responseData?.message
      });
      if (Array.isArray(responseData?.errors) && responseData.errors.length > 0) {
        responseData.errors.forEach((entry) => {
          notification.error({
            message: entry?.message || responseData?.message,
          });
        });
      }
      if (refreshQuery) {
        dispatch(getOrders(refreshQuery));
        dispatch(getOrderStatistics({
          ...(refreshQuery.startDate && { startDate: refreshQuery.startDate }),
          ...(refreshQuery.endDate && { endDate: refreshQuery.endDate }),
        }));
      }
      navigate && navigate("/orders");
      return true;
    })
    .catch((err) => {
      const responseData = err?.response?.data;
      const errors = responseData?.errors;
      if (Array.isArray(errors) && errors.length > 0) {
        errors.forEach((entry) => {
          notification.error({
            message: entry?.message || responseData?.message,
          });
        });
      } else {
        notification.error({
          message: responseData?.message
        });
      }
      console.log(err);
      dispatch({
        type: WAIT_FAIL
      });
      return false;
    });
};

export const sendOrderConfirmation = (data, refreshQuery) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.sendOrderConfirmation)
    .then((response) => {
      const { data: responseData } = response;
      dispatch({ type: WAIT_SUCCESS });
      notification.success({
        message: responseData?.message || "Confirmation sent",
      });
      if (Array.isArray(responseData?.errors) && responseData.errors.length > 0) {
        responseData.errors.forEach((entry) => {
          notification.error({
            message: entry?.message || responseData?.message,
          });
        });
      }
      if (refreshQuery) {
        dispatch(getOrders(refreshQuery));
      }
    })
    .catch((err) => {
      const responseData = err?.response?.data;
      const errors = responseData?.errors;
      if (Array.isArray(errors) && errors.length > 0) {
        errors.forEach((entry) => {
          notification.error({
            message: entry?.message || responseData?.message,
          });
        });
      } else {
        notification.error({
          message: responseData?.message,
        });
      }
      console.log(err);
      return dispatch({ type: WAIT_FAIL });
    });
};

export const sendOrderSdd = (data, refreshQuery) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.sendOrderSdd)
    .then((response) => {
      const { data: responseData } = response;
      dispatch({ type: WAIT_SUCCESS });
      notification.success({
        message: responseData?.message || "Order sent to Blink SDD",
        description: responseData?.trackingId
          ? `Tracking ID: ${responseData.trackingId}`
          : undefined,
      });
      if (responseData?.warning) {
        notification.warning({
          message: i18n.t("orders.sameDayAfterCutoffWarning"),
        });
      }
      if (refreshQuery) {
        dispatch(getOrders(refreshQuery));
      }
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message || "Failed to send order to SDD",
      });
      console.log(err);
      return dispatch({ type: WAIT_FAIL });
    });
};

export const sendOrderDefaultShipping = (data, refreshQuery) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.sendOrderDefaultShipping)
    .then((response) => {
      const { data: responseData } = response;
      dispatch({ type: WAIT_SUCCESS });
      notification.success({
        message: responseData?.message || "Order sent to brand default shipping",
        description: responseData?.trackingId
          ? `Tracking ID: ${responseData.trackingId}`
          : undefined,
      });
      if (refreshQuery) {
        dispatch(getOrders(refreshQuery));
      }
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message || "Failed to send order to default shipping",
      });
      console.log(err);
      return dispatch({ type: WAIT_FAIL });
    });
};

/**
 * Brand FlexShip setting. Stored on the vendor, not the partner user.
 * The login JWT vendor is stale until the next login — read and write this endpoint.
 * Do not send FlexShip fields when creating orders; the API attaches them.
 */
export const getFlexShipSettings = () => (dispatch, useState) => {
  const token = useState().auth?.token;
  if (!token) return Promise.resolve(false);

  return getRequest({}, undefined, token, endpoints.partner.flexship)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data,
        store: "flexShipSettings",
      });
      return data;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message || "Could not load FlexShip settings",
      });
      console.log(err);
      return false;
    });
};

export const updateFlexShipSettings = (data) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return putRequest(data, undefined, undefined, token, endpoints.partner.flexship)
    .then((response) => {
      const { data: responseData } = response;
      notification.success({
        message: responseData?.message || "FlexShip settings updated",
      });
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: responseData,
        store: "flexShipSettings",
      });
      dispatch({ type: WAIT_SUCCESS });
      return responseData;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message || "Could not save FlexShip settings",
      });
      console.log(err);
      dispatch({ type: WAIT_FAIL });
      return false;
    });
};

/** Refresh Partner.sddEnabled from API into auth.user (Shopify checkout SDD flag). */
export const getSddSettings = () => (dispatch, useState) => {
  const token = useState().auth?.token;
  const currentUser = useState().auth?.user;
  if (!token || !currentUser) return;

  getRequest({}, undefined, token, endpoints.partner.sdd)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          ...currentUser,
          sddEnabled: Boolean(data?.sddEnabled),
        },
        token,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const cancelOutboundItem = (data) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.cancelOutboundItem)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: WAIT_SUCCESS
      });
      notification.success({
        message: data?.message
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getNextPayout = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.expectedPayout)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getCashCycles = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.cashCycles)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getNoShippingOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.actionCenter.noShippingOrders)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLateFulfillmentOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.actionCenter.lateFulfillment)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLateDeliveryOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.actionCenter.lateDelivery)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getNotifications = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.notifications.root)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      navigate && navigate("/");
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getNotificationsCount = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.notifications.count)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      navigate && navigate("/");
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

// Returns System: Subscribe vendor
export const returnsSystemSubscribe = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: LOGIN });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.returnsSystem.subscribe)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data?.message });
      dispatch({
        type: LOGIN_SUCCESS,
        payload: data.partnerRefreshed,
        token: token
      });
      navigate && navigate("/returns-system");
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      return dispatch({ type: LOGIN_FAIL });
    });
};

// Returns System: Unsubscribe vendor
export const returnsSystemUnsubscribe = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: LOGIN });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.returnsSystem.unsubscribe)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data?.message });
      dispatch({
        type: LOGIN_SUCCESS,
        payload: data.partnerRefreshed,
        token: token
      });
      navigate && navigate("/returns-system");
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      return dispatch({ type: LOGIN_FAIL });
    });
};

// Returns System: Update customization (colors, logo, return policy, exchangeSameSkuOnly)
export const updateReturnsSystemCustomization = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  const currentUser = useState().auth?.user;

  putRequest(data, undefined, undefined, token, endpoints.partner.returnsSystem.customization)
    .then((response) => {
      const { data: resData } = response;
      notification.success({ message: resData?.message });
      const refreshed = resData?.partnerRefreshed || resData?.payload;
      if (refreshed) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: refreshed,
          token,
        });
      } else if (currentUser?.vendor) {
        // Keep local vendor in sync when API does not return a refreshed partner
        dispatch({
          type: LOGIN_SUCCESS,
          payload: {
            ...currentUser,
            vendor: {
              ...currentUser.vendor,
              ...data,
            },
          },
          token,
        });
      }
      return dispatch({ type: WAIT_SUCCESS });
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      return dispatch({ type: WAIT_FAIL });
    });
};

// Returns System: Update products flags (returnable/exchangable)
export const updateReturnsSystemProducts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.returnsSystem.updateProducts)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data?.message });
      return dispatch({ type: WAIT_SUCCESS });
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      return dispatch({ type: WAIT_FAIL });
    });
};

// Utility: get presigned upload URL for S3
export const getUploadUrl = (params) => (dispatch, useState) => {
  const token = useState().auth?.token;
  // Do not change loading state for utility
  return getRequest(params, undefined, token, endpoints.partner.uploadsUrl)
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      throw err;
    });
};

// Notification Settings (brand preferences)
export const getNotificationSettings = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.notifications.settings)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const updateNotificationSettings = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.partner.notifications.settings)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message || "Notification settings updated"
      });
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: { notificationSettings: data.notificationSettings }
      });
      return dispatch({ type: WAIT_SUCCESS });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const viewNotification = (data) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.notifications.view)
    .then((response) => {
      dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getReturnsSystemDashboard = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.partner.returnsSystem.dashboard)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: { returnsSystemDashboard: data }
      });
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      return dispatch({ type: FETCH_RECORDS_FAIL });
    });
};

export const getReturnRequests = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.returnsSystem.returnRequests)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: { returnRequests: data?.returnRequests }
      });
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      return dispatch({ type: FETCH_RECORDS_FAIL });
    });
};

export const getExchangeRequests = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.returnsSystem.exchangeRequests)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: { exchangeRequests: data?.exchangeRequests }
      });
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      return dispatch({ type: FETCH_RECORDS_FAIL });
    });
};

// Returns System - Single request fetchers and actions
export const getReturnRequestById = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.returnsSystem.returnRequests)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: { returnRequest: data?.returnRequest }
      });
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      return dispatch({ type: FETCH_RECORDS_FAIL });
    });
};

export const getExchangeRequestById = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.partner.returnsSystem.exchangeRequests)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: { exchangeRequest: data?.exchangeRequest }
      });
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      return dispatch({ type: FETCH_RECORDS_FAIL });
    });
};

export const approveReturnRequest = ({ returnRequestId, refundAmount }) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return postRequest({ returnRequestId, status: 'Approved', refundAmount }, undefined, undefined, token, `${endpoints.partner.returnsSystem.returnRequests}/respond`)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      return response;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};

export const rejectReturnRequest = ({ returnRequestId, reason }) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return postRequest({ returnRequestId, status: 'Rejected', rejectedReason: reason }, undefined, undefined, token, `${endpoints.partner.returnsSystem.returnRequests}/respond`)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      return response;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};

export const approveExchangeRequest = ({ exchangeRequestId, refundAmount }) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return postRequest({ exchangeRequestId, status: 'Approved', refundAmount }, undefined, undefined, token, `${endpoints.partner.returnsSystem.exchangeRequests}/respond`)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      return response;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};

export const rejectExchangeRequest = ({ exchangeRequestId, reason }) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return postRequest({ exchangeRequestId, status: 'Rejected', rejectedReason: reason }, undefined, undefined, token, `${endpoints.partner.returnsSystem.exchangeRequests}/respond`)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      return response;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      console.log(err);
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};

export const getBazaars = (data) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;
  getRequest(data, undefined, token, endpoints.partner.bazaars)
    .then((response) => dispatch({ type: FETCH_RECORDS_SUCCESS, payload: response.data }))
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: FETCH_RECORDS_FAIL });
    });
};

export const getBazaarSummary = (data) => (dispatch, useState) => {
  const token = useState().auth?.token;
  return getRequest(data, undefined, token, endpoints.partner.bazaarsSummary)
    .then((response) => {
      dispatch({ type: FETCH_RECORDS_SUCCESS, payload: { bazaarSummary: response.data.summary } });
      return response.data;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      throw err;
    });
};

export const getBazaar = (id, data) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;
  getRequest(data, `/${id}`, token, endpoints.partner.bazaars)
    .then((response) => dispatch({ type: FETCH_RECORDS_SUCCESS, payload: response.data }))
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: FETCH_RECORDS_FAIL });
    });
};

export const getBazaarStock = (id, data) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;
  getRequest(data, `/${id}/stock`, token, endpoints.partner.bazaars)
    .then((response) => dispatch({ type: FETCH_RECORDS_SUCCESS, payload: { bazaarStock: response.data.stock } }))
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: FETCH_RECORDS_FAIL });
    });
};

export const getBazaarPurchases = (id, data) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;
  getRequest(data, `/${id}/purchases`, token, endpoints.partner.bazaars)
    .then((response) => dispatch({ type: FETCH_RECORDS_SUCCESS, payload: { bazaarPurchases: response.data.purchases } }))
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: FETCH_RECORDS_FAIL });
    });
};

export const createBazaar = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  postRequest(data, undefined, undefined, token, endpoints.partner.bazaars)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      notification.success({ message: response.data.message });
      if (navigate) navigate(`/bazaars/${response.data.bazaar._id}`);
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
    });
};

export const updateBazaar = (id, data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  putRequest(data, undefined, `/${id}`, token, endpoints.partner.bazaars)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      notification.success({ message: response.data.message });
      if (navigate) navigate(`/bazaars/${id}`);
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
    });
};

export const deleteBazaar = (id, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  delRequest(undefined, `/${id}`, token, endpoints.partner.bazaars)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      notification.success({ message: response.data.message });
      if (navigate) navigate('/bazaars');
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
    });
};

export const lookupBazaarPurchase = (purchaseNumber) => (dispatch, useState) => {
  const token = useState().auth?.token;
  return getRequest({ purchaseNumber }, undefined, token, endpoints.partner.bazaarPurchaseLookup)
    .then((response) => response.data)
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      throw err;
    });
};

export const pulseSubscribe = () => (dispatch, useState) => {
  dispatch({ type: LOGIN });
  const token = useState().auth?.token;

  return postRequest({}, undefined, undefined, token, endpoints.partner.pulse.subscribe)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data?.message });
      if (data?.partnerRefreshed) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: data.partnerRefreshed,
          token,
        });
      }
      return data;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: LOGIN_FAIL });
      throw err;
    });
};

export const pulseUnsubscribe = () => (dispatch, useState) => {
  dispatch({ type: LOGIN });
  const token = useState().auth?.token;

  return postRequest({}, undefined, undefined, token, endpoints.partner.pulse.unsubscribe)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data?.message });
      if (data?.partnerRefreshed) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: data.partnerRefreshed,
          token,
        });
      }
      return data;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: LOGIN_FAIL });
      throw err;
    });
};